import {
  SECTIONS_SEPARATION_TECHNIQUE,
  type CoreTemplateSectionPositionData,
  type CoreTemplateIdentifierType,
} from '@models'

type SectionItem = CoreTemplateSectionPositionData<
  CoreTemplateIdentifierType<Record<string, unknown>>
>

export type CoreTemplateSectionRendererProps = {
  showDivider?: 'bottom'
  alternateSectionBg?: boolean
}

const isDarkSection = (section: SectionItem): boolean => {
  const sectionData = section as SectionItem & {
    darkBg?: boolean
    darkTheme?: boolean
  }
  return Boolean(sectionData.darkBg ?? sectionData.darkTheme)
}

export const getCoreTemplateSectionRendererProps = (
  sections: SectionItem[],
  sectionsSeparationTechnique: SECTIONS_SEPARATION_TECHNIQUE = SECTIONS_SEPARATION_TECHNIQUE.USING_DIVIDER
): CoreTemplateSectionRendererProps[] => {
  if (
    sectionsSeparationTechnique === SECTIONS_SEPARATION_TECHNIQUE.USING_DIVIDER
  ) {
    return sections.map(() => ({ showDivider: 'bottom' }))
  }

  let nextLightSectionUsesGrayBg = true

  return sections.map((section) => {
    const isDark = isDarkSection(section)

    if (isDark) {
      nextLightSectionUsesGrayBg = false
      return { alternateSectionBg: false }
    }

    const alternateSectionBg = nextLightSectionUsesGrayBg
    nextLightSectionUsesGrayBg = !nextLightSectionUsesGrayBg

    return { alternateSectionBg }
  })
}
